module.exports = __webpack_public_path__ + "static/media/therapies-to-discuss-blue.b54c7c17.svg";